import { driver, type DriveStep } from 'driver.js'
import 'driver.js/dist/driver.css'
import { useI18n } from 'vue-i18n'

export function useGuidedTour() {
  const { t } = useI18n()

  function startTour() {
    const steps: DriveStep[] = [
      {
        element: '[data-tour="sidebar-toggle"]',
        popover: {
          title: t('general.tour.sidebarToggleTitle'),
          description: t('general.tour.sidebarToggleDescription'),
        },
      },
      {
        element: '[data-tour="chapter-nav"]',
        popover: {
          title: t('general.tour.chapterNavTitle'),
          description: t('general.tour.chapterNavDescription'),
        },
      },
      {
        element: '[data-tour="validation-icon"]',
        popover: {
          title: t('general.tour.validationIconTitle'),
          description: t('general.tour.validationIconDescription'),
        },
      },
      {
        element: '[data-tour="settings-button"]',
        popover: {
          title: t('general.tour.settingsTitle'),
          description: t('general.tour.settingsDescription'),
        },
      },
      {
        element: '[data-tour="export-draft-button"]',
        popover: {
          title: t('general.tour.draftTitle'),
          description: t('general.tour.draftDescription'),
        },
      },
      {
        element: '[data-tour="import-button"]',
        popover: {
          title: t('general.tour.importTitle'),
          description: t('general.tour.importDescription'),
        },
      },
      {
        element: '[data-tour="download-pdf-button"]',
        popover: {
          title: t('general.tour.downloadPdfTitle'),
          description: t('general.tour.downloadPdfDescription'),
        },
      },
    ]

    const driverObj = driver({
      showProgress: true,
      allowClose: true,
      overlayClickBehavior: 'close',
      // driver.js templates its own {{current}}/{{total}} placeholders; feeding those
      // literally through vue-i18n's t() makes its message compiler choke on the
      // braces, so the translation carries %current%/%total% and gets swapped here.
      progressText: t('general.tour.progressText')
        .replace('%current%', '{{current}}')
        .replace('%total%', '{{total}}'),
      nextBtnText: t('general.tour.next'),
      prevBtnText: t('general.tour.previous'),
      doneBtnText: t('general.tour.done'),
      steps,
    })

    driverObj.drive()
  }

  return { startTour }
}
